export default __webpack_public_path__ + "assets/6166526717d864fe2377092d73a7c2e8.jpg";